import { Plane } from "lucide-react";
import { useVacationMode, isVacationActive, formatVacationRange } from "@/hooks/useVacationMode";

export function VacationBanner() {
  const { data } = useVacationMode();
  if (!isVacationActive(data)) return null;

  const range = formatVacationRange(data!);
  const message =
    data?.message?.trim() ||
    `Kim is out of town${range ? ` ${range}` : ""}. Orders and inquiries will be answered on her return.`;

  return (
    <div className="w-full bg-amber-100 text-amber-950 border-b border-amber-300/60 dark:bg-amber-900/40 dark:text-amber-50 dark:border-amber-800/60">
      <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-2 text-xs sm:text-sm font-medium text-center">
        <Plane className="h-4 w-4 shrink-0" aria-hidden />
        <p>{message}</p>
      </div>
    </div>
  );
}